import React, {useEffect, useState} from 'react'
import axios from 'axios'
import  CustomPagination from '../components/CustomPagination'
import './Trending.css'
import SingleContent from '../components/SingleContent';

function Trending() {
    const [page, setPage] = useState(1);
    const [content, setContent] = useState([]);

    const fetchTrending = async () => {
        const { data } = await axios.get(
          `https://api.themoviedb.org/3/trending/all/day?api_key=70f54dd636b287d66344d1fc88acd2e2&page=${page}`
      
        );
    
        console.log(data.results)
        setContent(data.results);
      };

      useEffect(() => {
        window.scroll(0, 0);
        fetchTrending();
      }, [page]);

    return (
        <div>
            <span className = 'page-title'>Trending</span>
            <div className = "trending">
                {content && content.map((item) =>
                  <SingleContent
                  key={item.id}
                  id={item.id}
                  poster={item.poster_path}
                  title={item.title || item.name}
                  date={item.first_air_date || item.release_date}
                  media_type={item.media_type}
                  vote_average={item.vote_average}
                  />
                  
                )}

            </div>
            <CustomPagination setPage={setPage}/>
        </div>
    )
}

export default Trending
